import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { CSSTransition } from 'react-transition-group';
import { getSpecFont } from '../../utils/fontClass/index';
import styles from './index.less';
import { getSpecStyle, getSpecScale, getSpecLeft } from './utils';

export default function Device({ step, begin, event }) {
  const { t, i18n } = useTranslation();
  const execfn = useRef(null);
  const doms = useRef({
    play_cube: null,
    play_top_left: null,
    play_top_right: null,
    play_center: null,
    play_center_1: null,
    play_center_2: null,
    play_center_3: null,
    play_center_4: null,
    play_center_box_1: null,
    play_center_box_2: null,
    play_center_num: null,
    play_bottom: null,
    play_bottom_1: null,
    play_bottom_2: null,
    play_bottom_3: null,
    play_bottom_4: null,
    play_bottom_left: null,
    play_bottom_right: null,
    play_energy: null
  });
  const [beginShow, setBeginShow] = useState(false);
  // 开始引导
  const beginAction = () => {
    setBeginShow(false);
    // 延迟
    setTimeout(() => {
      begin();
    }, 510);
  };

  // 保存dom
  const markDom = useCallback((key, ref) => {
    doms.current[key] = ref;
  }, []);

  const animation = useCallback((_step) => {
    if (execfn.current) {
      execfn.current();
    }
    switch (_step) {
      // 步骤1
      case 1:
        execfn.current = () => {};
        break;
      // 步骤2
      case 2:
        doms.current.play_bottom.style.zIndex = 4;
        execfn.current = () => {
          doms.current.play_bottom.style.zIndex = 1;
        };
        break;
      // 步骤3
      case 3:
        doms.current.play_bottom.style.zIndex = 4;
        doms.current.play_bottom_2.className += ' card-scale-bigger';
        execfn.current = () => {
          doms.current.play_bottom.style.zIndex = 1;
          let classes = doms.current.play_bottom_2.className;
          classes = classes.replace(' card-scale-bigger', '');
          doms.current.play_bottom_2.className = classes;
        };
        break;
      // 步骤4
      case 4:
        doms.current.play_energy.style.zIndex = 4;
        execfn.current = () => {
          doms.current.play_energy.style.zIndex = 1;
        };
        break;
      // 步骤5
      case 5:
        doms.current.play_center_box_1.style.zIndex = 4;
        doms.current.play_center_box_1.style.opacity = 1;

        doms.current.play_bottom.style.zIndex = 4;
        doms.current.play_bottom_2.className += ' card-move-to-box';
        execfn.current = () => {
          doms.current.play_center_box_1.style.zIndex = 1;
          doms.current.play_center_box_1.style.opacity = 0;

          doms.current.play_bottom.style.zIndex = 1;
          let classes = doms.current.play_bottom_2.className;
          classes = classes.replace(' card-move-to-box', '');
          doms.current.play_bottom_2.className = classes;
        };
        break;
      // 步骤6
      case 6:
        doms.current.play_center.style.zIndex = 4;
        execfn.current = () => {
          doms.current.play_center.style.zIndex = 1;
        };
        break;
      // 步骤7
      case 7:
        doms.current.play_center_box_2.style.zIndex = 4;
        doms.current.play_center_box_2.style.opacity = 1;
        doms.current.play_center.style.zIndex = 4;

        doms.current.play_bottom.style.zIndex = 4;
        doms.current.play_bottom_3.className += ' card-move-to-center';
        doms.current.play_center_2.style.display = 'none';
        doms.current.play_center_4.style.display = 'block';
        setTimeout(() => {
          doms.current.play_center_num.innerHTML = '1';
        }, 2000);
        execfn.current = () => {
          doms.current.play_center_box_2.style.zIndex = 1;
          doms.current.play_center_box_2.style.opacity = 0;
          doms.current.play_center.style.zIndex = 1;

          doms.current.play_bottom.style.zIndex = 1;
          let classes = doms.current.play_bottom_3.className;
          classes = classes.replace(' card-move-to-center', '');
          doms.current.play_bottom_3.className = classes;

          doms.current.play_center_2.style = '';
          doms.current.play_center_4.style = '';
          doms.current.play_center_num.innerHTML = '0';
        };
        break;
      // 步骤8
      case 8:
        doms.current.play_cube.style.zIndex = 4;
        execfn.current = () => {
          doms.current.play_cube.style.zIndex = 1;
        };
        break;
      // 步骤9
      case 9:
        doms.current.play_cube.style.zIndex = 4;
        execfn.current = () => {
          doms.current.play_cube.style.zIndex = 1;
        };
        break;
      // 步骤10
      case 10:
        doms.current.play_bottom_left.style.zIndex = 4;
        execfn.current = () => {
          doms.current.play_bottom_left.style.zIndex = 1;
        };
        break;
      // 步骤11
      case 11:
        doms.current.play_bottom_right.style.zIndex = 4;
        execfn.current = () => {
          doms.current.play_bottom_right.style.zIndex = 1;
        };
        break;
    }
  }, []);

  const name = t('_marvel_snap_');

  useEffect(() => {
    if (execfn.current) {
      execfn.current();
    }
  }, [event]);

  useEffect(() => {
    if (step == 0) {
      return;
    }
    setTimeout(() => {
      animation(step);
    }, 350);
  }, [step]);

  useEffect(() => {
    setTimeout(() => {
      setBeginShow(true);
    }, 2000);
  }, []);

  return (
    <div styleName="wrapper">
      <div styleName="play-top-cube" ref={(ref) => markDom('play_cube', ref)}>
        8
      </div>
      <div styleName="play-top-left" ref={(ref) => markDom('play_top_left', ref)}>
        <span styleName="ava-words ava-l">{t('handsomedaniel')}</span>
      </div>
      <div styleName="play-top-right" ref={(ref) => markDom('play_top_right', ref)}>
        <span styleName="ava-words ava-r">{t('diego')}</span>
      </div>
      <div styleName="play-center" ref={(ref) => markDom('play_center', ref)}>
        <div styleName="play-center-1" ref={(ref) => markDom('play_center_1', ref)}>
          <p styleName="cen-words cen-top">{t('kyln')}</p>
          <p
            styleName={'cen-words cen-bom ' + getSpecStyle(i18n.language)}
            className={getSpecFont(i18n.language)}
          >
            {t('you_can_t_play_cards_here_after_turn_4_')}
          </p>
        </div>
        <div styleName="play-center-2" ref={(ref) => markDom('play_center_2', ref)}>
          <p
            styleName={'cen-words cen-bom ' + getSpecStyle(i18n.language)}
            className={getSpecFont(i18n.language)}
          >
            {t('will_be_revealed_next_turn_')}
          </p>
        </div>
        <div styleName="play-center-2 play-center-4" ref={(ref) => markDom('play_center_4', ref)}>
          <p styleName="cen-words cen-top">{t('lechuguilla')}</p>
          <p
            styleName={'cen-words cen-bom ' + getSpecStyle(i18n.language)}
            className={getSpecFont(i18n.language)}
          >
            {t('when_you_play_a_card_here__shuttle_3_rocks_into_your_deck_')}
          </p>
          <span styleName="cen-num num-top">0</span>
          <span styleName="cen-num num-bom" ref={(ref) => markDom('play_center_num', ref)}>
            0
          </span>
        </div>
        <div styleName="play-center-3" ref={(ref) => markDom('play_center_3', ref)}>
          <p
            styleName={'cen-words cen-bom ' + getSpecStyle(i18n.language)}
            className={getSpecFont(i18n.language)}
          >
            {t('will_be_revealed_in_2_turns_')}
          </p>
        </div>
      </div>
      <div styleName="play-center-box" ref={(ref) => markDom('play_center_box_1', ref)}></div>
      <div
        styleName="play-center-box p_c_b2"
        ref={(ref) => markDom('play_center_box_2', ref)}
      ></div>
      <div styleName="play-bottom-area" ref={(ref) => markDom('play_bottom', ref)}>
        <div styleName="play-bottom-1" ref={(ref) => markDom('play_bottom_1', ref)}></div>
        <div styleName="play-bottom-2" ref={(ref) => markDom('play_bottom_2', ref)}></div>
        <div styleName="play-bottom-3" ref={(ref) => markDom('play_bottom_3', ref)}></div>
        <div styleName="play-bottom-4" ref={(ref) => markDom('play_bottom_4', ref)}></div>
      </div>
      <div styleName="play-energy" ref={(ref) => markDom('play_energy', ref)}></div>
      <div styleName="play-bottom-left" ref={(ref) => markDom('play_bottom_left', ref)}>
        <span
          styleName="bom-words bom-l"
          style={getSpecLeft(i18n.language)}
          className={getSpecFont(i18n.language)}
        >
          {t('retreat')}
        </span>
      </div>
      <div styleName="play-bottom-right" ref={(ref) => markDom('play_bottom_right', ref)}>
        <span styleName="bom-words bom-r" style={getSpecScale(i18n.language)}>
          <span className={getSpecFont(i18n.language)}>{t('end_the_round')}</span>
          <span>1/6</span>
        </span>
      </div>
      <CSSTransition in={beginShow} timeout={500} classNames="begin" unmountOnExit={true}>
        <div styleName="begin">
          <span className={'begin-title ' + getSpecFont(i18n.language)}>{t('how_to_play')}</span>
          <p
            className={'begin-text ' + (getSpecFont(i18n.language, false) || '')}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: t(
                '{name}_has_both_easy_to_use_gameplay_and_exciting_and_exciting_experience__which',
                {
                  name: '($name)'
                }
              ).replace('($name)', `${`<span class="${styles.heavy}">${name}</span>`}`)
            }}
          ></p>
          <div className={'begin-btn ' + getSpecFont(i18n.language)} onClick={beginAction}>
            {t('begin')}
          </div>
        </div>
      </CSSTransition>
      <div styleName="mask"></div>
    </div>
  );
}
